;
var sprite = require("/tmp/build_133e1b25/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Close_d9a0b6df63419d50f522af50a0c3f8cc\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M22.949,19.933L50,46.983l27.051-27.051l3.017,3.017L53.017,50l27.051,27.051l-3.017,3.017L50,53.017L22.949,80.067\r\n\t\tl-3.017-3.017L46.983,50L19.933,22.949L22.949,19.933z\"/> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Close_d9a0b6df63419d50f522af50a0c3f8cc");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Close.svg
// module id = 1404
// module chunks = 0